module.exports = __webpack_public_path__ + "img/deodorizer_line.a8797db3.svg";